

const serverUrl = window.location.origin;

const LogoutButton = () => {
logout();

  return (
    <div></div>
  );
};

function logout(){

  //Call Api - for log out 
  window.location.href = serverUrl + "/auth/logout"
  
}

export default LogoutButton;